<div class="page-container">
  <div class="page-header">
    <h1>Utilisateurs</h1>
    <p>Liste de tous les utilisateurs LaBase (lecture seule)</p>
  </div>

  @if (isLoading) {
    <div class="loading">
      Chargement des utilisateurs...
    </div>
  }

  @if (!isLoading) {
    <div class="search-container">
      <div class="search-box">
        <i class="pi pi-search search-icon"></i>
        <input
          type="text"
          class="search-input"
          placeholder="Rechercher un utilisateur (nom, email, profil...)"
          [(ngModel)]="searchText"
          (input)="onSearch()"
        />
        @if (searchText) {
          <i class="pi pi-times clear-icon" (click)="searchText = ''; onSearch()"></i>
        }
      </div>

      <button
        class="btn-print"
        (click)="printSelection()"
        [disabled]="isLoading"
        title="Imprimer la sélection"
      >
        <i class="pi pi-print"></i>
        <span>Imprimer</span>
      </button>
    </div>

    <div class="print-header" style="display: none;">
      <h1 class="print-title">Liste des utilisateurs</h1>
      <p class="print-subtitle">
        {{ selectedUsers.length > 0 ? selectedUsers.length + ' utilisateur(s) sélectionné(s)' : 'Tous les utilisateurs (' + users.length + ')' }}
      </p>
      <p class="print-date">Imprimé le {{ currentDate | date:'dd MMMM yyyy à HH:mm':'fr-FR' }}</p>
    </div>

    <div class="grid-container">
      <ag-grid-angular
        class="ag-theme-balham"
        [rowData]="users"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowSelection]="rowSelection"
        [theme]="theme"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [domLayout]="'autoHeight'"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      >
      </ag-grid-angular>
    </div>
  }
</div>
